import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, DestroyRef,  Inject, OnDestroy, OnInit, PLATFORM_ID, inject, input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ParamFilters } from '@app/models/filtermodels/ParamFilters';
import { Partner } from '@app/models/partner/IPartner';
import { AcvisService } from '@app/services/acvis.service';
import { HotelFiltersService } from '@app/services/hotelfilters.service';
import { Observable, Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'clever-facility-list',
    templateUrl: './facility-list.component.html',
    styleUrls: ['./facility-list.component.scss'],
    standalone: false
})
export class FacilityListComponent implements OnInit {
    readonly mode = input<string>(undefined);
    readonly partner = input<Partner>(undefined);
    protected unsubscribe$ = new Subject();
    isBrowser: boolean = false;
    slicenbr: number = 5;
    facilityList: any[];

    selectedList: string[] = [];
    destroyRef = inject(DestroyRef);
    constructor(
        @Inject(PLATFORM_ID) protected platformId: any,
        protected acvisService: AcvisService,
        protected hotelService: HotelFiltersService,
        protected cdr: ChangeDetectorRef
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    ngOnInit(): void {
        if (this.isBrowser) {
            this.initFilterSub();
            this.initfacilityList();
        }
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    initfacilityList(): void {
        this.acvisService.request({}, 'facilitylist').pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe(res => {
            this.checktypes(res);
        });
    }

    checktypes(array) {
        for (let i = 0; i < array.length; i++) {
            if(this.partner()?.filters?.['hideausstattung' + array[i].code + 'filter']) {
                array.splice(i, 1);
                i--;
            }
        }

        this.facilityList = this.sortArray(array);
        this.cdr.detectChanges();
    }

    sortArray(array): any[] {
        if (array?.length > 0) {
            array?.sort((a, b) => {
                a = a.name.toLowerCase();
                b = b.name.toLowerCase();

                return a < b ? -1 : a > b ? 1 : 0;
            });
        }
        return array;
    }

    showMore(all) {
        this.slicenbr = all;
    }

    initFilterSub(): void {
        this.hotelService.getfilters$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((filter: ParamFilters) => {
            this.selectedList = [];
            if (filter.facilityList?.length > 0) {
                for (let i = 0; i < filter.facilityList.length; i++) {
                    this.selectedList.push(filter.facilityList[i].code);
                }
            }
            this.cdr.detectChanges();
        });
    }

    selected(op): void {
        let push = true;
        if (this.selectedList.indexOf(op.code) >= 0) {
            push = false;
        }
        this.hotelService.facilityList(op, push, this.mode() !== 'home');
        this.cdr.detectChanges();
    }
}
